import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  position: relative;
`;

export const BuilderContainer = styled.div`
  width: 100%;
  margin: 5px 0;
  min-height: 50px;
  position: relative;
`;